import { lazy } from "react";

const FLAG = "chunk_reload_attempted";

// After a deploy the old hashed chunk files are gone, so lazy imports held by
// an already-open tab fail. Reload the page once to pick up the fresh asset
// manifest; the sessionStorage flag prevents a reload loop — a second failure
// falls through to the ErrorBoundary as before.
const lazyWithRetry = (importer) =>
  lazy(() =>
    importer()
      .then((module) => {
        sessionStorage.removeItem(FLAG);
        return module;
      })
      .catch((error) => {
        if (!sessionStorage.getItem(FLAG)) {
          sessionStorage.setItem(FLAG, "1");
          window.location.reload();
          return new Promise(() => {}); // page is reloading; never settle
        }
        throw error;
      })
  );

export default lazyWithRetry;
